const map = {
	"./2_title_background.png": 2715,
	"./2_title_background.webp": 77257,
	"./7up7down.webp": 16912,
	"./BB88-NewCommission-bcg-4.png": 27621,
	"./BB88-NewCommission-bcg-4.webp": 72607,
	"./BB88_desktop.webp": 12778,
	"./BB88_mobile.webp": 67856,
	"./BETGAMES.webp": 57511,
	"./BIGGAMING.webp": 66804,
	"./BOMBAYLIVE.webp": 11325,
	"./Bangladesh.png": 98812,
	"./Bangladesh.webp": 85788,
	"./BigG.jpg": 73454,
	"./BigG.webp": 51302,
	"./Cambodia.png": 28445,
	"./Cambodia.webp": 76395,
	"./DRAGONSOFT.webp": 89470,
	"./E1SPORT.webp": 84211,
	"./EVOPLAY.webp": 17329,
	"./EZUGI.webp": 75370,
	"./FASTSPIN.webp": 31763,
	"./Flag-Cambodia.png": 29122,
	"./Flag-Cambodia.webp": 39236,
	"./Flag_of_Bangladesh.svg.png": 76529,
	"./Flag_of_Bangladesh.svg.webp": 34759,
	"./Flag_of_Brazil.svg.png": 28260,
	"./Flag_of_Brazil.svg.webp": 5568,
	"./Flag_of_India.svg.png": 35001,
	"./Flag_of_India.svg.webp": 72241,
	"./Flag_of_philippines.svg.jpg": 55229,
	"./Flag_of_philippines.svg.webp": 28133,
	"./India.png": 83378,
	"./India.webp": 9188,
	"./LUDO.webp": 4783,
	"./Layer 10 copy 2.png": 29676,
	"./Layer 10 copy 2.webp": 22418,
	"./Layer 10 copy.png": 17222,
	"./Layer 10 copy.webp": 80256,
	"./ONETOUCH.webp": 29178,
	"./REDTIGER.webp": 43275,
	"./ROYALGAMING.webp": 66465,
	"./SABAVIRTUAL.webp": 84459,
	"./SEXYBCRT.webp": 21351,
	"./SPADEGAMING.webp": 34747,
	"./SPRIBE.webp": 92482,
	"./SUPERSPADE.webp": 91457,
	"./SV388.webp": 38025,
	"./Slider-Alternative-Link-BCG.webp": 39448,
	"./YL.webp": 52008,
	"./abc.png": 22051,
	"./abc.webp": 78363,
	"./aeSexy.webp": 87692,
	"./age18.png": 87117,
	"./age18.webp": 9017,
	"./agentAff.svg": 56811,
	"./any_jackson.png": 77719,
	"./any_jackson.webp": 30227,
	"./arrow.png": 44504,
	"./arrow.webp": 18226,
	"./background1.jpg": 61242,
	"./background1.webp": 14740,
	"./background1mb.jpg": 48927,
	"./background1mb.webp": 52411,
	"./background2.jpg": 83845,
	"./background2.webp": 74001,
	"./bank.png": 7369,
	"./bank.webp": 42143,
	"./banner-1.png": 25651,
	"./banner-1.webp": 51881,
	"./banner-2.png": 51160,
	"./banner-2.webp": 57612,
	"./banner-3.png": 23873,
	"./banner-3.webp": 32495,
	"./banner-4.webp": 93490,
	"./banner-image-1.jpg": 16555,
	"./banner-image-1.webp": 86229,
	"./banner-image-2.jpg": 48252,
	"./banner-image-2.webp": 51272,
	"./banner1.jpg": 17088,
	"./banner1.webp": 30406,
	"./banner2.jpg": 30703,
	"./banner2.webp": 20839,
	"./banner3.jpg": 46418,
	"./banner3.webp": 74596,
	"./banner4.jpg": 14433,
	"./banner4.webp": 59925,
	"./batch.svg": 28029,
	"./bb88_downloadnow_appbanner_desktop.webp": 70071,
	"./bd-flag.webp": 29508,
	"./bettingPass.svg": 98087,
	"./bg-disabled.png": 11981,
	"./bg-disabled.webp": 47237,
	"./bg-fanctbet_rules.svg": 45020,
	"./bg-match-btn-left-select.png": 2602,
	"./bg-match-btn-left-select.webp": 87918,
	"./bg-match-btn-left.png": 37679,
	"./bg-match-btn-left.webp": 71339,
	"./bg-match-btn-right.png": 25952,
	"./bg-match-btn-right.webp": 15412,
	"./bg-sportsbook_rules.svg": 88205,
	"./bg.png": 91386,
	"./bg.webp": 63010,
	"./bkash-logo.png": 63682,
	"./bkash-logo.webp": 51662,
	"./bkash.png": 81360,
	"./bkash.webp": 96366,
	"./bologna.png": 57725,
	"./bologna.webp": 65377,
	"./bonus-1.png": 41532,
	"./bonus-1.webp": 77978,
	"./bonus-2.png": 30263,
	"./bonus-2.webp": 81179,
	"./bonus-3.png": 56622,
	"./bonus-3.webp": 88376,
	"./bonus-4.png": 23361,
	"./bonus-4.webp": 13297,
	"./bookmaker.svg": 11164,
	"./bournemouth.png": 86239,
	"./bournemouth.webp": 73827,
	"./btc.svg": 23092,
	"./btg.png": 38090,
	"./btg.webp": 45476,
	"./btm-18.svg": 184,
	"./btn-android-dl.webp": 49640,
	"./card-triangle.svg": 73494,
	"./cardmatka.webp": 62643,
	"./cash-rocket.webp": 42521,
	"./casino-back.png": 6948,
	"./casino-back.webp": 97454,
	"./casino-logo.png": 68904,
	"./casino-logo.webp": 52889,
	"./casino.png": 23942,
	"./casino.webp": 63638,
	"./casino/casino/casino1.webp": 43401,
	"./casino/casino/casino10.webp": 48695,
	"./casino/casino/casino11.webp": 6836,
	"./casino/casino/casino2.webp": 32684,
	"./casino/casino/casino3.webp": 6127,
	"./casino/casino/casino4.webp": 67346,
	"./casino/casino/casino5.webp": 53757,
	"./casino/casino/casino6.webp": 75856,
	"./casino/casino/casino7.webp": 98067,
	"./casino/casino/casino8.webp": 20310,
	"./casino/casino/casino9.webp": 85041,
	"./casino/crash/JILI-TABLE-030.webp": 63146,
	"./casino/crash/JILI-TABLE-035.webp": 29569,
	"./casino/crash/JILI-TABLE-047.webp": 24220,
	"./casino/crash/KM-TABLE-015.webp": 53957,
	"./casino/crash/KM-TABLE-021.webp": 14114,
	"./casino/crash/KM-TABLE-022.webp": 37891,
	"./casino/crash/KM-TABLE-028.webp": 9173,
	"./casino/crash/KM-TABLE-060.webp": 58705,
	"./casino/crash/pgdragon.webp": 46917,
	"./casino/cricket/cricket1.webp": 99733,
	"./casino/cricket/cricket2.webp": 99976,
	"./casino/fishing/fishing_fc.webp": 77072,
	"./casino/fishing/fishing_jbd.webp": 80461,
	"./casino/fishing/fishing_jili.webp": 62421,
	"./casino/fishing/fishing_spg.webp": 81845,
	"./casino/fishing/fishing_yb.webp": 73936,
	"./casino/fishing/fishing_yl.webp": 61526,
	"./casino/fishing/jili/DinosaurTycoon.webp": 45656,
	"./casino/fishing/jili/allstarfishing.webp": 61708,
	"./casino/fishing/jili/bombayfishing.webp": 66725,
	"./casino/fishing/jili/happyfishing.webp": 13875,
	"./casino/fishing/jili/jackpotfishing.webp": 11479,
	"./casino/fishing/jili/megafishing.webp": 81197,
	"./casino/fishing/jili/oceanking.webp": 97008,
	"./casino/fishing/spade/alienhunter.webp": 56219,
	"./casino/fishing/spade/fishinggold.webp": 61970,
	"./casino/fishing/spade/zombieparty.webp": 89072,
	"./casino/hot-casino/hot1.webp": 97605,
	"./casino/hot-casino/hot10.webp": 63387,
	"./casino/hot-casino/hot11.webp": 20568,
	"./casino/hot-casino/hot12.webp": 4965,
	"./casino/hot-casino/hot13.webp": 83866,
	"./casino/hot-casino/hot14.webp": 4279,
	"./casino/hot-casino/hot15.webp": 62420,
	"./casino/hot-casino/hot2.webp": 17432,
	"./casino/hot-casino/hot3.webp": 55803,
	"./casino/hot-casino/hot4.webp": 3958,
	"./casino/hot-casino/hot5.webp": 20337,
	"./casino/hot-casino/hot6.webp": 53620,
	"./casino/hot-casino/hot7.webp": 64631,
	"./casino/hot-casino/hot8.webp": 34482,
	"./casino/hot-casino/hot9.webp": 59197,
	"./casino/slot/fc.webp": 97983,
	"./casino/slot/jdb.webp": 7736,
	"./casino/slot/jili.webp": 65662,
	"./casino/slot/jili/JILI-SLOT-129.webp": 28083,
	"./casino/slot/jili/JILI-SLOT-148.png": 67438,
	"./casino/slot/jili/JILI-SLOT-148.webp": 2682,
	"./casino/slot/jili/agentace.jpg": 839,
	"./casino/slot/jili/agentace.webp": 22891,
	"./casino/slot/jili/alibaba.webp": 60761,
	"./casino/slot/jili/boxingking.jpg": 97207,
	"./casino/slot/jili/boxingking.webp": 47431,
	"./casino/slot/jili/crazyhunter.jpg": 52830,
	"./casino/slot/jili/crazyhunter.webp": 45346,
	"./casino/slot/jili/fortunegems.jpg": 37252,
	"./casino/slot/jili/fortunegems.webp": 40,
	"./casino/slot/jili/goldenempire.jpg": 37088,
	"./casino/slot/jili/goldenempire.webp": 47982,
	"./casino/slot/jili/goldenland.webp": 19347,
	"./casino/slot/jili/jungleking.jpg": 50853,
	"./casino/slot/jili/jungleking.webp": 8793,
	"./casino/slot/jili/luckycoming.jpg": 17782,
	"./casino/slot/jili/luckycoming.webp": 48282,
	"./casino/slot/jili/magiclamp.jpg": 26676,
	"./casino/slot/jili/magiclamp.webp": 18756,
	"./casino/slot/jili/mayanempire.webp": 75359,
	"./casino/slot/jili/moneycoming.webp": 8974,
	"./casino/slot/jili/partynight.jpg": 11885,
	"./casino/slot/jili/partynight.webp": 11049,
	"./casino/slot/jili/pharaohtreasure.jpg": 94819,
	"./casino/slot/jili/pharaohtreasure.webp": 61297,
	"./casino/slot/jili/romex.jpg": 31538,
	"./casino/slot/jili/romex.webp": 58246,
	"./casino/slot/jili/streettreasure.jpg": 63413,
	"./casino/slot/jili/streettreasure.webp": 40973,
	"./casino/slot/jili/superace.webp": 31709,
	"./casino/slot/jili/superrion.jpg": 87634,
	"./casino/slot/jili/superrion.webp": 21898,
	"./casino/slot/jili/twinwins.webp": 66058,
	"./casino/slot/km.png": 2384,
	"./casino/slot/km.webp": 99112,
	"./casino/slot/new/fc.webp": 27464,
	"./casino/slot/new/jdb.webp": 21941,
	"./casino/slot/new/jili.webp": 38029,
	"./casino/slot/new/pg.webp": 49530,
	"./casino/slot/new/playtech.webp": 62813,
	"./casino/slot/new/pp.webp": 4935,
	"./casino/slot/new/rt.webp": 14797,
	"./casino/slot/new/sg.webp": 45869,
	"./casino/slot/new/yb.webp": 71640,
	"./casino/slot/new/yl.webp": 51054,
	"./casino/slot/pg.webp": 85133,
	"./casino/slot/pp.webp": 22028,
	"./casino/slot/pt.webp": 91376,
	"./casino/slot/rt.webp": 6030,
	"./casino/slot/sg.webp": 56506,
	"./casino/slot/yes-bingo.webp": 94509,
	"./casino/slot/yl.webp": 51853,
	"./casino/sports/saba_sports.webp": 36562,
	"./casino/table/jili/7up7down.jpg": 47616,
	"./casino/table/jili/7up7down.webp": 90148,
	"./casino/table/jili/ak47.jpg": 5716,
	"./casino/table/jili/ak47.webp": 73224,
	"./casino/table/jili/andarbhar.jpg": 34138,
	"./casino/table/jili/andarbhar.webp": 21108,
	"./casino/table/jili/callbreak.jpg": 3226,
	"./casino/table/jili/callbreak.webp": 13320,
	"./casino/table/jili/dice.jpg": 56246,
	"./casino/table/jili/dice.webp": 75846,
	"./casino/table/jili/dragontiger.jpg": 79613,
	"./casino/table/jili/dragontiger.webp": 49881,
	"./casino/table/jili/joker.jpg": 93010,
	"./casino/table/jili/joker.webp": 49368,
	"./casino/table/jili/journeywest.jpg": 84542,
	"./casino/table/jili/journeywest.webp": 23408,
	"./casino/table/jili/numberking.jpg": 24357,
	"./casino/table/jili/numberking.webp": 20075,
	"./casino/table/jili/pokerking.jpg": 35657,
	"./casino/table/jili/pokerking.webp": 26997,
	"./casino/table/jili/richbingo.jpg": 8452,
	"./casino/table/jili/richbingo.webp": 63450,
	"./casino/table/jili/rummy.jpg": 26105,
	"./casino/table/jili/rummy.webp": 31493,
	"./casino/table/jili/sicbo.jpg": 89821,
	"./casino/table/jili/sicbo.webp": 53761,
	"./casino/table/kingmaker/32cards.webp": 16120,
	"./casino/table/kingmaker/5cardpoker.webp": 98282,
	"./casino/table/kingmaker/7up7down.webp": 92721,
	"./casino/table/kingmaker/andarbahar.webp": 69414,
	"./casino/table/kingmaker/animalrace.webp": 39673,
	"./casino/table/kingmaker/baccarat.webp": 43197,
	"./casino/table/kingmaker/bingoroll.webp": 97264,
	"./casino/table/kingmaker/blackjack.webp": 20628,
	"./casino/table/kingmaker/bolagolek.webp": 35326,
	"./casino/table/kingmaker/bonusdice.webp": 92404,
	"./casino/table/kingmaker/cardhilo.webp": 64392,
	"./casino/table/kingmaker/cardmatka.webp": 44116,
	"./casino/table/kingmaker/cashrocket.webp": 94483,
	"./casino/table/kingmaker/cointoss.webp": 55430,
	"./casino/table/kingmaker/colorgame.webp": 22457,
	"./casino/table/kingmaker/dota.webp": 54518,
	"./casino/table/kingmaker/horseracing.webp": 17747,
	"./casino/table/kingmaker/houndracing.webp": 37936,
	"./casino/table/kingmaker/jhandimunda.webp": 85577,
	"./casino/table/kingmaker/ludo.webp": 68370,
	"./casino/table/kingmaker/marbleknockout.webp": 34873,
	"./casino/table/kingmaker/minesweeper.webp": 40282,
	"./casino/table/kingmaker/monkeyking.webp": 7446,
	"./casino/table/kingmaker/numbermatka.webp": 76345,
	"./casino/table/kingmaker/plinko.webp": 47305,
	"./casino/table/kingmaker/sicbo.webp": 43558,
	"./casino/table/kingmaker/taixiu.webp": 58240,
	"./casino/table/kingmaker/tangkas.webp": 18809,
	"./casino/table/kingmaker/teenpatti.webp": 27638,
	"./casino/table/kingmaker/thaihilo.webp": 92940,
	"./casino/table/kingmaker/treadmillracing.webp": 2816,
	"./casino/table/spade/belangakai.webp": 19455,
	"./casino/table/spade/dragontiger.webp": 19042,
	"./casino/table/spade/fishprawn.webp": 21834,
	"./casino/table/spade/pokdeng.webp": 49738,
	"./casino/table/spade/roulette.webp": 64724,
	"./casino/table/spade/sedie.webp": 75490,
	"./casino/table/spade/sicbo.webp": 80914,
	"./casino/table/spade/thaifish.webp": 72280,
	"./casino/table/table_jili.webp": 83489,
	"./casino/table/table_km.webp": 92775,
	"./casino/table/table_ludo.webp": 5693,
	"./casino/table/table_pg.webp": 21742,
	"./casino/table/table_spg.webp": 87449,
	"./casinobingo.svg": 25931,
	"./casinocrash.svg": 32355,
	"./casinoegame.svg": 58345,
	"./casinoesports.svg": 45138,
	"./casinofishing.svg": 95664,
	"./casinogameshow.svg": 86055,
	"./casinolive.svg": 71788,
	"./casinolotto.svg": 83948,
	"./casinoslot.svg": 38134,
	"./casinotable.svg": 52686,
	"./casinovirtual.svg": 743,
	"./chat.png": 98753,
	"./chat.webp": 20059,
	"./complete-bg.png": 69144,
	"./complete-bg.webp": 39690,
	"./cover-live.webp": 58649,
	"./crose.svg": 20403,
	"./cross-black.svg": 47707,
	"./down-popup-bg.png": 62524,
	"./down-popup-bg.webp": 51514,
	"./download-apk.png": 2374,
	"./download-apk.webp": 37750,
	"./download-app.png": 10677,
	"./download-app.webp": 58719,
	"./downloadApp.svg": 96028,
	"./downloadnow_appbanner.webp": 19677,
	"./dreamLogo.png": 279,
	"./dreamLogo.svg": 66965,
	"./dreamLogo.webp": 22251,
	"./entrance.svg": 67277,
	"./esport.webp": 18238,
	"./eth.svg": 51656,
	"./event_bg.webp": 90131,
	"./evo.png": 26887,
	"./evo.webp": 23847,
	"./evolution-new.webp": 37425,
	"./evolution.webp": 87834,
	"./exchange.svg": 30724,
	"./expand-close.png": 82612,
	"./expand-close.webp": 3704,
	"./expand-open.png": 3602,
	"./expand-open.webp": 43908,
	"./facebook-f.png": 88358,
	"./facebook-f.webp": 65210,
	"./facebook-login.png": 38443,
	"./facebook-login.webp": 3549,
	"./facebook.png": 32799,
	"./facebook.webp": 55469,
	"./fancybet.svg": 63075,
	"./faq.svg": 32397,
	"./fastspin.png": 81225,
	"./fav1.jpg": 31935,
	"./fav1.webp": 13517,
	"./fav2.jpg": 64560,
	"./fav2.webp": 18848,
	"./fav3.jpg": 9453,
	"./fav3.webp": 72547,
	"./fav4.jpg": 9606,
	"./fav4.webp": 72542,
	"./favicon.jpg": 42227,
	"./favicon.webp": 56527,
	"./fc.png": 84714,
	"./fc.webp": 57834,
	"./feature-1.jpg": 93395,
	"./feature-1.webp": 77043,
	"./feature-2.jpg": 67172,
	"./feature-2.webp": 69394,
	"./feature-3.jpg": 40769,
	"./feature-3.webp": 94109,
	"./feature-4.jpg": 17170,
	"./feature-4.webp": 33516,
	"./feature-5.jpg": 93551,
	"./feature-5.webp": 8399,
	"./feature-6.jpg": 3232,
	"./feature-6.webp": 15406,
	"./feature-7.jpg": 71325,
	"./feature-7.webp": 11433,
	"./feature-8.png": 42682,
	"./feature-8.webp": 35992,
	"./first.png": 15257,
	"./first.webp": 26181,
	"./fishicon.webp": 84790,
	"./flag-symbolism-Pakistan-design-Islamic.png": 51345,
	"./flag-symbolism-Pakistan-design-Islamic.webp": 37451,
	"./form-bg.png": 23213,
	"./form-bg.webp": 57733,
	"./form-icon-user.svg": 74683,
	"./gift_bg.png": 69599,
	"./gift_bg.webp": 75931,
	"./gift_icon.png": 95525,
	"./gift_icon.webp": 51749,
	"./google-login.png": 42186,
	"./google-login.webp": 48834,
	"./gurubuzz-wht.png": 77055,
	"./gurubuzz-wht.webp": 5165,
	"./hansika.png": 93966,
	"./hansika.webp": 58228,
	"./header-appdownload-icon.svg": 19460,
	"./header-logout-icon.svg": 74515,
	"./header-service-icon.svg": 31420,
	"./home-banner-1.jpg": 89833,
	"./home-banner-1.webp": 11581,
	"./home-banner-2.jpg": 98334,
	"./home-banner-2.webp": 68752,
	"./home-banner-3.jpg": 18491,
	"./home-banner-3.webp": 78163,
	"./home-banner-4.jpg": 13608,
	"./home-banner-4.webp": 80974,
	"./home-banner-5.jpg": 57573,
	"./home-banner-5.webp": 20073,
	"./home.png": 40078,
	"./home.webp": 9706,
	"./home_bg.png": 77402,
	"./home_bg.webp": 40620,
	"./horse-racing.svg": 36169,
	"./horse-racing.webp": 75991,
	"./horseracing.png": 31770,
	"./horseracing.webp": 19108,
	"./hot-casino/JILI-TABLE-030.webp": 65328,
	"./hot-casino/JILI-TABLE-035.webp": 95599,
	"./hot-casino/JILI-TABLE-047.webp": 3554,
	"./hot-casino/KM-TABLE-015.webp": 57111,
	"./hot-casino/KM-TABLE-021.webp": 94352,
	"./hot-casino/KM-TABLE-022.webp": 88605,
	"./hot-casino/KM-TABLE-028.webp": 7163,
	"./hot-casino/KM-TABLE-060.webp": 37287,
	"./hot-casino/aviator.png": 15171,
	"./hot-casino/aviator.webp": 46769,
	"./hot-casino/bgroll.webp": 71821,
	"./hot-casino/bgsicbo.webp": 26900,
	"./hot-casino/bgspeedsicbo.webp": 6929,
	"./hot-casino/evolightdice.webp": 12022,
	"./hot-casino/evoligtroullete.webp": 6041,
	"./hot-casino/evospeedroullete.webp": 60092,
	"./hot-casino/evosupersicbo.webp": 96032,
	"./hot-casino/evoteenpatti.webp": 59239,
	"./hot-casino/pbaccarat.webp": 12706,
	"./hot-casino/pcoinflip.webp": 5261,
	"./hot-casino/pcrazytime.webp": 13077,
	"./hot-casino/pdt.webp": 95103,
	"./hot-casino/pgdragon.webp": 63579,
	"./hot-casino/playtech-teen-patti.webp": 90357,
	"./hot-casino/pmegaroll.webp": 97710,
	"./hot-casino/pmegasicbo.webp": 70385,
	"./hot-casino/pmegawheel.webp": 34680,
	"./hot-casino/pmonopoly.webp": 23698,
	"./hot-casino/ppbacarrat2.webp": 39401,
	"./hot-casino/ppsicbo.webp": 70229,
	"./hot-casino/pthilo.webp": 44683,
	"./hot-casino/ptspinwin.webp": 88413,
	"./hot-icon.png": 5150,
	"./hot-icon.webp": 41022,
	"./hotroad.png": 77568,
	"./hotroad.webp": 80534,
	"./icon-TV_close.svg": 6242,
	"./icon-abous-us.svg": 66020,
	"./icon-affiliate.png": 54586,
	"./icon-affiliate.webp": 35950,
	"./icon-ambassador.png": 42268,
	"./icon-ambassador.webp": 65930,
	"./icon-arrow.svg": 80576,
	"./icon-awcmbc.png": 30930,
	"./icon-awcmbc.webp": 81376,
	"./icon-bet-records.png": 32407,
	"./icon-bet-records.webp": 27813,
	"./icon-bottom-left.png": 54266,
	"./icon-bottom-left.webp": 99346,
	"./icon-bottom-right.png": 39895,
	"./icon-bottom-right.webp": 79539,
	"./icon-checked.png": 15604,
	"./icon-checked.webp": 74264,
	"./icon-clock.svg": 32125,
	"./icon-deposit.png": 71741,
	"./icon-deposit.webp": 51987,
	"./icon-email.png": 84839,
	"./icon-email.webp": 2329,
	"./icon-exchange.png": 15960,
	"./icon-exchange.svg": 98430,
	"./icon-exchange.webp": 74338,
	"./icon-facebook-messenger.png": 90793,
	"./icon-facebook-messenger.webp": 6013,
	"./icon-faq.svg": 80067,
	"./icon-forum.png": 436,
	"./icon-forum.webp": 61176,
	"./icon-fromto.png": 60276,
	"./icon-fromto.webp": 3346,
	"./icon-home.png": 7690,
	"./icon-home.webp": 38692,
	"./icon-horsebook.svg": 35091,
	"./icon-inbox.png": 63951,
	"./icon-inbox.webp": 96657,
	"./icon-kabaddi.png": 38355,
	"./icon-kabaddi.svg": 44151,
	"./icon-kabaddi.webp": 73541,
	"./icon-member-talk.svg": 5286,
	"./icon-profile.png": 688,
	"./icon-profile.webp": 48072,
	"./icon-promotion.webp": 95700,
	"./icon-records.png": 41705,
	"./icon-records.webp": 72103,
	"./icon-referral.png": 33108,
	"./icon-referral.svg": 82842,
	"./icon-referral.webp": 99830,
	"./icon-resetpasswords.png": 37858,
	"./icon-resetpasswords.webp": 1840,
	"./icon-sbov2.svg": 32373,
	"./icon-sbtech.png": 61640,
	"./icon-sbtech.webp": 48186,
	"./icon-sportbook.png": 45714,
	"./icon-sportbook.svg": 91178,
	"./icon-sportbook.webp": 2598,
	"./icon-spribe.png": 9678,
	"./icon-spribe.webp": 41804,
	"./icon-talk.png": 76213,
	"./icon-talk.webp": 79737,
	"./icon-telegram.svg": 36300,
	"./icon-top-left.png": 74162,
	"./icon-top-left.webp": 8276,
	"./icon-top-right.png": 29007,
	"./icon-top-right.webp": 74389,
	"./icon-turnover.png": 59328,
	"./icon-turnover.webp": 35674,
	"./icon-ugv3.svg": 50768,
	"./icon-vip.png": 49318,
	"./icon-vip.webp": 55718,
	"./icon-virtual.svg": 81962,
	"./icon-whatsapp.png": 71837,
	"./icon-whatsapp.webp": 44453,
	"./icon-withdrawal.png": 47178,
	"./icon-withdrawal.webp": 98104,
	"./icon_close.png": 97689,
	"./icon_close.webp": 97027,
	"./income.png": 38402,
	"./income.webp": 25538,
	"./index-announcement-icon.svg": 56187,
	"./invite.png": 27152,
	"./invite.webp": 15352,
	"./invite_bg.png": 77364,
	"./invite_bg.webp": 9066,
	"./invite_icon.png": 88974,
	"./invite_icon.webp": 91824,
	"./jackpot-banner.png": 66790,
	"./jackpot-banner.webp": 14490,
	"./jdb.png": 50719,
	"./jdb.webp": 58931,
	"./jilii.png": 65044,
	"./jilii.webp": 43578,
	"./jililobby.webp": 24541,
	"./join-babu-section-bg.webp": 30646,
	"./join-banner.png": 54288,
	"./join-banner.webp": 83318,
	"./jp-title.png": 78248,
	"./jp-title.webp": 81736,
	"./kingmaker.webp": 87870,
	"./km.png": 60935,
	"./km.webp": 49745,
	"./kv-virtual-cricket-m.jpg": 2186,
	"./kv-virtual-cricket-m.webp": 99022,
	"./leadge.png": 8397,
	"./leadge.webp": 34847,
	"./left-arrow.png": 99540,
	"./left-arrow.webp": 91564,
	"./left.png": 28808,
	"./left.webp": 44728,
	"./level-01.png": 9401,
	"./level-01.webp": 45819,
	"./level-02.png": 61218,
	"./level-02.webp": 42618,
	"./level-03.png": 82347,
	"./level-03.webp": 14117,
	"./level-04.png": 36436,
	"./level-04.webp": 2324,
	"./level-05.png": 57565,
	"./level-05.webp": 41687,
	"./level-06.png": 16326,
	"./level-06.webp": 4310,
	"./level-07.png": 55343,
	"./level-07.webp": 77937,
	"./level-08.png": 87864,
	"./level-08.webp": 25552,
	"./level-09.png": 72481,
	"./level-09.webp": 51315,
	"./level-info-bg.png": 58214,
	"./level-info-bg.webp": 60668,
	"./live-chat.png": 59586,
	"./live-chat.webp": 22976,
	"./live_casino1.webp": 4926,
	"./live_casino2.webp": 16863,
	"./livechat.png": 92839,
	"./livechat.webp": 58813,
	"./loader.png": 25226,
	"./loader.webp": 41470,
	"./loading-bet.webp": 79505,
	"./loading_bet.webp": 30167,
	"./login-banner1.png": 1356,
	"./login-banner1.webp": 78230,
	"./login-banner2.webp": 15607,
	"./login-banner3.webp": 92596,
	"./login-icon.png": 32976,
	"./login-icon.webp": 70696,
	"./logo-9wicket.svg": 93273,
	"./logo-c-old.png": 78738,
	"./logo-c-old.webp": 70298,
	"./logo-c.png": 75566,
	"./logo-c.webp": 61062,
	"./logo-sky.svg": 26398,
	"./logo-velki-.png": 86019,
	"./logo-velki-.webp": 21239,
	"./logo-velki.png": 54524,
	"./logo-velki.svg": 85476,
	"./logo-velki.webp": 46456,
	"./logo-yl.svg": 86372,
	"./logo.png": 82806,
	"./logo.webp": 11238,
	"./logout.svg": 10589,
	"./ludo.png": 94369,
	"./lv18.png": 40134,
	"./lv18.webp": 22306,
	"./lv9.png": 5180,
	"./lv9.webp": 22782,
	"./main-bg.png": 65450,
	"./main-bg.webp": 96800,
	"./mall-bg.png": 64913,
	"./mall-bg.webp": 15113,
	"./mall-bg1.png": 70172,
	"./mall-bg1.webp": 23316,
	"./member-header-bg.png": 29995,
	"./member-header-bg.webp": 46353,
	"./member-info-bg.png": 77618,
	"./member-info-bg.webp": 58914,
	"./money_bg.png": 3629,
	"./money_bg.webp": 45355,
	"./money_icon.png": 87215,
	"./money_icon.webp": 28309,
	"./mybets.png": 38313,
	"./mybets.webp": 55235,
	"./mypin-star-sprit-black.png": 84836,
	"./mypin-star-sprit-black.webp": 22724,
	"./nagad.png": 59446,
	"./nagad.webp": 19008,
	"./news.png": 12782,
	"./news.webp": 37778,
	"./next.png": 73216,
	"./next.webp": 57640,
	"./nl-yellow.svg": 88766,
	"./no-data.png": 9977,
	"./no-data.webp": 67753,
	"./otp-verify.webp": 55860,
	"./pak.png": 79739,
	"./pak.webp": 23795,
	"./parlay-check.svg": 8737,
	"./path_arrow.svg": 11796,
	"./pdf-icon.png": 85351,
	"./pdf-icon.webp": 84173,
	"./pg.png": 10036,
	"./pg.webp": 52360,
	"./popular-casino/7up7down.webp": 38222,
	"./popular-casino/andarbahar.webp": 74809,
	"./popular-casino/aviator.webp": 35931,
	"./popular-casino/cointoss.webp": 66861,
	"./popular-casino/crazycoinflip.webp": 27854,
	"./popular-casino/crazytime.webp": 96129,
	"./popular-casino/dragontiger.webp": 93571,
	"./popular-casino/funkytime.webp": 5317,
	"./popular-casino/lightingroulette.webp": 43855,
	"./popular-casino/monopoly.webp": 67870,
	"./popular-casino/supersicbo.webp": 38868,
	"./popup-header.png": 23619,
	"./popup-header.webp": 21705,
	"./pp.png": 34875,
	"./pp.webp": 44529,
	"./pragmatic-play.webp": 93744,
	"./profile.png": 45572,
	"./profile.webp": 94250,
	"./promo_bg.png": 41170,
	"./promo_bg.webp": 97434,
	"./promo_icon.png": 17808,
	"./promo_icon.webp": 3552,
	"./promot.svg": 84320,
	"./promotion-bg.svg": 10118,
	"./promotion.svg": 9090,
	"./promotion1.jpg": 45563,
	"./promotion1.webp": 55021,
	"./promotion2.jpg": 2764,
	"./promotion2.webp": 76704,
	"./provider-awcmfastspin.png": 20905,
	"./provider-awcmfastspin.webp": 32745,
	"./provider-awcmhorsebook.png": 65131,
	"./provider-awcmhorsebook.webp": 22617,
	"./provider-awcmp8.png": 40195,
	"./provider-awcmp8.webp": 13783,
	"./provider-awcmsv388.png": 45021,
	"./provider-awcmsv388.webp": 5007,
	"./provider-awcmyesbingo.png": 34921,
	"./provider-awcmyesbingo.webp": 52273,
	"./provider-bg.png": 91050,
	"./provider-bg.webp": 15908,
	"./provider-bpoker.png": 77698,
	"./provider-bpoker.webp": 40992,
	"./provider-cmd.png": 39387,
	"./provider-cmd.webp": 80141,
	"./provider-cq9.png": 77754,
	"./provider-cq9.webp": 28810,
	"./provider-cricket.png": 78470,
	"./provider-cricket.webp": 51798,
	"./provider-jdbaspribe.png": 98039,
	"./provider-jdbaspribe.webp": 37767,
	"./provider-joker.png": 46374,
	"./provider-joker.webp": 11250,
	"./provider-ka.png": 56619,
	"./provider-ka.webp": 5491,
	"./provider-mg.png": 72443,
	"./provider-mg.webp": 38132,
	"./provider-netent.png": 75139,
	"./provider-netent.webp": 96699,
	"./provider-number.png": 16920,
	"./provider-number.webp": 61710,
	"./provider-playngo.png": 34362,
	"./provider-playngo.webp": 83563,
	"./provider-ps.png": 97456,
	"./provider-ps.webp": 88306,
	"./provider-rich88.png": 30121,
	"./provider-rich88.webp": 70105,
	"./provider-saba-sportbook.png": 89958,
	"./provider-saba-sportbook.webp": 27116,
	"./provider-saba.png": 97252,
	"./provider-saba.webp": 72554,
	"./provider-sbov2.png": 66125,
	"./provider-sbov2.webp": 8663,
	"./provider-sbtech.png": 16052,
	"./provider-sbtech.webp": 89246,
	"./provider-ugv3.png": 98034,
	"./provider-ugv3.webp": 67304,
	"./provider-wm.png": 56051,
	"./provider-wm.webp": 98059,
	"./provider-worldmatch.png": 83108,
	"./provider-worldmatch.webp": 29102,
	"./pt.png": 7871,
	"./pt.webp": 89733,
	"./ptNew.jpg": 98245,
	"./ptNew.webp": 92377,
	"./referAndEarn.svg": 62380,
	"./referral-banner.webp": 89589,
	"./reward-right.png": 45343,
	"./reward-right.webp": 48425,
	"./reward.png": 42862,
	"./reward.webp": 71358,
	"./rewards.svg": 44781,
	"./right-arrow.png": 53809,
	"./right-arrow.webp": 58605,
	"./right.png": 48349,
	"./right.webp": 2321,
	"./rocket.png": 91027,
	"./rocket.webp": 10865,
	"./rt.png": 16561,
	"./rt.webp": 48451,
	"./saba-sport.png": 36597,
	"./saba-sport.webp": 48335,
	"./saba.png": 88052,
	"./saba.webp": 64120,
	"./sabas.png": 62885,
	"./sabas.webp": 75117,
	"./search2.svg": 66559,
	"./second.png": 85415,
	"./second.webp": 26001,
	"./security-center.png": 67587,
	"./security-center.webp": 12447,
	"./select-check.svg": 93276,
	"./sexy.png": 39630,
	"./sexy.webp": 88286,
	"./sg.png": 74133,
	"./sg.webp": 95063,
	"./share-icon1.png": 82549,
	"./share-icon1.webp": 88105,
	"./share-icon2.png": 45822,
	"./share-icon2.webp": 10188,
	"./share-icon3.png": 37959,
	"./share-icon3.webp": 85071,
	"./share-icon4.png": 58344,
	"./share-icon4.webp": 46066,
	"./share-icon5.png": 90385,
	"./share-icon5.webp": 70781,
	"./share-icon6.png": 30490,
	"./share-icon6.webp": 27952,
	"./sicbo.webp": 26901,
	"./sign-arrow.png": 75300,
	"./sign-arrow.webp": 29008,
	"./sign-up.png": 27608,
	"./sign-up.webp": 29002,
	"./sign.png": 85355,
	"./sign.webp": 42100,
	"./sky-logo.png": 8190,
	"./sky-logo.webp": 18866,
	"./spade.webp": 36134,
	"./sports.png": 1050,
	"./sports.webp": 15270,
	"./sportsBanner.png": 15116,
	"./sportsBanner.webp": 8112,
	"./sportsbook.svg": 61761,
	"./support-f.png": 53491,
	"./support-f.webp": 84755,
	"./support.svg": 90140,
	"./sv.webp": 65572,
	"./tab-icon/casino.svg": 66376,
	"./tab-icon/crash.svg": 32722,
	"./tab-icon/cricket.svg": 98326,
	"./tab-icon/fishing.svg": 43317,
	"./tab-icon/hot.svg": 9374,
	"./tab-icon/mobileBottomNavigation/account-withdrawal.svg": 36636,
	"./tab-icon/mobileBottomNavigation/account.svg": 61996,
	"./tab-icon/mobileBottomNavigation/acount-referral.svg": 3705,
	"./tab-icon/mobileBottomNavigation/deposit_active.svg": 62888,
	"./tab-icon/mobileBottomNavigation/home.svg": 8890,
	"./tab-icon/mobileBottomNavigation/promotion.svg": 28470,
	"./tab-icon/mobileBottomNavigation/referral.svg": 73552,
	"./tab-icon/money.png": 77907,
	"./tab-icon/money.webp": 47897,
	"./tab-icon/slot.svg": 31205,
	"./tab-icon/sports.svg": 83552,
	"./tab-icon/table.svg": 56679,
	"./tab-icon/withdraw.png": 65809,
	"./tab-icon/withdraw.webp": 21601,
	"./taka.png": 64502,
	"./taka.webp": 85414,
	"./task_bg.png": 38224,
	"./task_bg.webp": 97214,
	"./task_icon.png": 69042,
	"./task_icon.webp": 3116,
	"./telegram-f.png": 80655,
	"./telegram-f.webp": 14009,
	"./telegram.png": 5970,
	"./telegram.svg": 78646,
	"./telegram.webp": 65418,
	"./temu-amount-bg.png": 29567,
	"./temu-amount-bg.webp": 12777,
	"./temu-history-bg.png": 62883,
	"./temu-history-bg.webp": 7279,
	"./toolbar-icon-bet-records.png": 90037,
	"./toolbar-icon-bet-records.webp": 6255,
	"./toolbar-icon-casino.webp": 96074,
	"./toolbar-icon-deposit.svg": 41519,
	"./toolbar-icon-home.svg": 42570,
	"./toolbar-icon-mine.svg": 92434,
	"./toolbar-icon-promotion.svg": 98854,
	"./top-1.png": 32208,
	"./top-1.webp": 11050,
	"./top-2.png": 2059,
	"./top-2.webp": 43691,
	"./top-3.png": 80930,
	"./top-3.webp": 9448,
	"./top-text-1.png": 84238,
	"./top-text-1.webp": 90058,
	"./top-text-2.png": 38245,
	"./top-text-2.webp": 6347,
	"./top-text-3.png": 55356,
	"./top-text-3.webp": 88456,
	"./top.png": 36322,
	"./top.webp": 54708,
	"./trc20.svg": 20018,
	"./unmatched.svg": 18626,
	"./upay.png": 29438,
	"./upay.webp": 70522,
	"./upgrade-bg.png": 37383,
	"./upgrade-bg.webp": 97093,
	"./userImage.png": 36179,
	"./userImage.webp": 65415,
	"./velki-back.webp": 18920,
	"./velki-bg-login.webp": 26452,
	"./velki-logo.png": 42188,
	"./velki-logo.webp": 14192,
	"./venus-p.png": 79979,
	"./venus-p.webp": 6443,
	"./venus.png": 29948,
	"./venus.webp": 63442,
	"./virtual.svg": 41880,
	"./whatsapp-f.webp": 78720,
	"./whatsapp.png": 92841,
	"./whatsapp.svg": 83465,
	"./whatsapp.webp": 37047,
	"./yesbingo.svg": 96033,
	"./yl.png": 60356,
	"./youtube.png": 22616,
	"./youtube.webp": 24210
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 13170;